import * as types from "./actionTypes";
import * as routeApi from "../../api/routesApi";
import { beginApiCall, apiCallError, apiCallUnAuthorised } from "./apiStatusActions";
import { ActionCreators as UndoActionCreators } from 'redux-undo'

export function loadRoutesSuccess(routes) {
    return { type: types.LOAD_ROUTES_SUCCESS, routes }; 
}

export function loadRouteSuccess(route) {
    return { type: types.LOAD_ROUTE_SUCCESS, route }; 
}

export function routeClear() {
    return { type: types.CLEAR_ROUTE };
}

export function updateRouteSuccess(route) {
    return { type: types.UPDATE_ROUTE_SUCCESS, route };
}

export function createRouteSuccess(route) {
    return { type: types.CREATE_ROUTE_SUCCESS, route };
}

export function routeDeleted(route) {
    return { type: types.DELETE_ROUTE, route };
}

export function addBookmarkOptimistic(route) {
    return { type: types.ADD_BOOKMARK_OPTIMISTIC, route };
}

export function removeBookmarkOptimistic(route) {
    return { type: types.REMOVE_BOOKMARK_OPTIMISTIC, route };
}

export function setRouteSearchMapCriteria(routeMapSearchState) {
    return { type: types.UPDATE_MAP_SEARCHCRITERIA, routeMapSearchState };
}

export function setRouteSearchCriteria(routeSearchCriteria) {
    return { type: types.UPDATE_ROUTE_SEARCHCRITERIA, routeSearchCriteria };
}

export function loadRoutesSearchResults(results) {
    return { type: types.LOAD_ROUTES_SEARCH_SUCCESS, results };
}

export function loadRoutesMyRoutesResults(results) {
    return { type: types.LOAD_ROUTES_MYROUTES_SUCCESS, results };
}

export function loadRouteBookmarksResults(results) {
    return { type: types.LOAD_ROUTES_BOOKMARKS_SUCCESS, results };
}

export function updateDraftMapType(mapType) {
    return { type: types.UPDATE_DRAFTROUTE_MAPTYPE, mapType }
}

export function updateDraftZoom(zoom) {
    return { type: types.UPDATE_DRAFTROUTE_ZOOM, zoom };
}

export function updateDraftCentre(centre) {
    return { type: types.UPDATE_DRAFTROUTE_CENTRE, centre };
}

export function resetRouteCreatorState() {
    return { type: types.CLEAR_DRAFTROUTE_STATE}
}

export function addDraftPoints(points) {
    return { type: types.ADD_DRAFTROUTE_POINTS, points };
}

export function deleteDraftPoint(index) {
    return { type: types.DELETE_DRAFTROUTE_POINT, index };
}

export function moveDraftPoint(point, index) {
    return { type: types.MOVE_DRAFTROUTE_POINT, point, index  };
}

export function insertDraftPoint(point, index) {
    return { type: types.INSERT_DRAFTROUTE_POINT, point, index  };
}

export function draftRouteSave(draftRoute) {
    return { type: types.SAVE_DRAFTROUTE, draftRoute };
}

export function draftRouteClear() {
    return { type: types.CLEAR_DRAFTROUTE };
}

export function updateDraftCreateMode(createMode) {
    return { type: types.UPDATE_DRAFTROUTE_CREATEMODE, createMode };
}

export function updateDraftPlotMode(plotMode) {
    return { type: types.UPDATE_DRAFTROUTE_PLOTMODE, plotMode };
}

export function updateDraftAutoMode(autoMode) {
    return { type: types.UPDATE_DRAFTROUTE_AUTOMODE, autoMode };
}

export function setReCentreOnLoad(value) {
    return { type: types.SET_RECENTREONLOAD, value };
}

export function setEditRoute(details) {
    return { type: types.SET_DRAFTROUTE_EDIT_ID, details };
}

export function clearEditRoute() {
    return { type: types.CLEAR_DRAFTROUTE_EDIT_ID };
}

export function routeSharedWithGroup(route, group) {
    return { type: types.SHARE_ROUTE, route, group };
}

export function removeRouteShareOptimistic(route, group) {
    return { type: types.REMOVE_ROUTE_SHARE_OPTIMISTIC, route, group };
}

export function reactedToRoute(reaction) {
    return { type: types.REACT_ROUTE, reaction };
}

export function unReactedToRoute(reaction) {
    return { type: types.UNREACT_ROUTE, reaction };
}

export function changeReactionToRoute(reaction) {
    return { type: types.CHANGE_REACTION_ROUTE, reaction };
}

export function loadRoutes(searchCriteria, mode) {
    return function (dispatch) {
        dispatch(beginApiCall()); 
        return routeApi.getRoutes(searchCriteria).then(routes => {
            var results = { routes: routes, searchCriteria: searchCriteria }
            switch (mode) {
                case "search":
                    dispatch(loadRoutesSearchResults(results));
                    break;
                case "myroutes":
                    dispatch(loadRoutesMyRoutesResults(results));
                    break;
                case "bookmarks":
                    dispatch(loadRouteBookmarksResults(results));
                    break; 
            }
            return routes; 

            //dispatch(setRouteSearchCriteria(searchCriteria));
            //dispatch(loadRoutesSuccess(routes));
        }).catch(error => {
            if (error.message === "401") {
                dispatch(apiCallUnAuthorised());
            } else {
                dispatch(apiCallError(error));
            }
            throw error;
        });
    }
}

export function loadRoute(id, bearer) {
    return function (dispatch) {
        dispatch(beginApiCall()); 
        return routeApi.getRoute(id, bearer).then(route => {
            dispatch(loadRouteSuccess(route));
            return route;
        }).catch(error => {
            if (error.message === "401") {
                dispatch(apiCallUnAuthorised());
            } else {
                dispatch(apiCallError(error));
            }
            throw error;
        });
    }
}


export function clearRoute() {
    return function (dispatch) {
        dispatch(routeClear());
    }
}


export function saveRoute(route) {
    return function (dispatch, getState) {
        dispatch(beginApiCall()); 
        var routeDetails = { routeId: route.routeId, name: route.name, category: route.category, description: route.description, private: route.private }
        return routeApi.saveRoute(routeDetails)
            .then((id) => {
                dispatch(updateRouteSuccess(route));
                return id;
            })
            .catch(error => {
                if (error === "401") {
                    dispatch(apiCallUnAuthorised());
                } else {
                    dispatch(apiCallError(error));
                }
                throw error;
            });
    }
} 

export function toggleBookmark(route) {
   return function (dispatch) {
       if (route.bookmarked) {
            route.bookmarked = false; 
            dispatch(removeBookmarkOptimistic(route));
            return routeApi.removeBookmark(route);
       }
       else {
            route.bookmarked = true; 
            dispatch(addBookmarkOptimistic(route));
            return routeApi.addBookmark(route);
       }

    } 
}

export function react(reaction) {
    return function (dispatch) {
        routeApi.react(reaction)
            .then(() => {
                dispatch(reactedToRoute(reaction));
            })
            .catch(error => {
                if (error === "401") {
                    dispatch(apiCallUnAuthorised());
                } else {
                    dispatch(apiCallError(error));
                }
                throw error;
            });
    }
}

export function unReact(reaction) {
    return function (dispatch) {
        routeApi.unReact(reaction)
            .then(() => {
                dispatch(unReactedToRoute(reaction));
            })
            .catch(error => {
                if (error === "401") {
                    dispatch(apiCallUnAuthorised());
                } else {
                    dispatch(apiCallError(error));
                }
                throw error;
            });
    }
}

export function changeReaction(reaction) {
    return function (dispatch) {
        routeApi.changeReaction(reaction)
            .then(() => {
                dispatch(changeReactionToRoute(reaction));
            })
            .catch(error => {
                if (error === "401") {
                    dispatch(apiCallUnAuthorised());
                } else {
                    dispatch(apiCallError(error));
                }
                throw error;
            });
    }
}

export function deleteRoute(route) {
    return function (dispatch) {
        return routeApi.deleteRoute(route.routeId)
            .then(() => {
                dispatch(routeDeleted(route));
                return;
            })
            .catch(error => {
                if (error === "401") {
                    dispatch(apiCallUnAuthorised());
                } else {
                    dispatch(apiCallError(error));
                }
                throw error;
            });
    }
}

export function searchRouteViewpoint(ne, sw, loadedRoutes) {
    return function (dispatch) {
        return routeApi.searchRouteViewpoint(ne, sw, loadedRoutes)
    }
}


export function updateRouteSearchMapCriteria(routeMapSearchState) {
    return function (dispatch) {
        dispatch(setRouteSearchMapCriteria(routeMapSearchState));
    }
}

export function updateRouteSearchCriteria(routeSearchCriteria) {
    return function (dispatch) {
        dispatch(setRouteSearchCriteria(routeSearchCriteria));
    }
}

export function updateDraftRouteMapType(mapType) {
    return function (dispatch) {
        dispatch(updateDraftMapType(mapType));
    }
}

export function updateDraftRouteMapCentre(centre) {
    return function (dispatch) {
        dispatch(updateDraftCentre(centre));
    }
}

export function updateDraftRouteMapZoom(zoom) {
    return function (dispatch) {
        dispatch(updateDraftZoom(zoom));
    }
}

export function updateDraftRoutePlotMode(plotMode) {
    return function (dispatch) {
        dispatch(updateDraftPlotMode(plotMode));
    }
}

export function updateDraftRouteAutoMode(autoMode) {
    return function (dispatch) {
        dispatch(updateDraftAutoMode(autoMode));
    }
}

export function updateDraftRouteCreateMode(createMode) {
    return function (dispatch) {
        dispatch(updateDraftCreateMode(createMode));
    }
}


export function addDraftRouteMapPoints(points) {
    return function (dispatch) {
        dispatch(addDraftPoints(points));
    }
}

export function deleteDraftRouteMapPoint(index) {
    return function (dispatch) {
        dispatch(deleteDraftPoint(index));
    }
}

export function moveDraftRouteMapPoint(point, index) {
    return function (dispatch) {
        dispatch(moveDraftPoint(point, index));
    }
}

export function insertDraftRouteMapPoint(point, index) {
    return function (dispatch) {
        dispatch(insertDraftPoint(point, index));
    }
}

export function saveDraftRoute(draftRoute) {
    return function (dispatch) {

        let points = [];
        draftRoute.present.map(point => {
            points.push({
                latitude: point.lat,
                longitude: point.lng,
                elevation: point.ele
            })
        });

        let routeSaveData = {};

        if (draftRoute.routeId) {
            routeSaveData = {
                points: points,
                routeId: draftRoute.routeId
            }
        }else
        {
            routeSaveData = {
                name: draftRoute.details.name,
                description: draftRoute.details.description,
                category: draftRoute.details.category,
                private: draftRoute.details.private,
                method: "Creator",
                points: points,
            }
            
        }

        return routeApi.saveRoute(routeSaveData)
            .then(route => {
                dispatch(draftRouteClear());
                dispatch(resetRouteCreatorState());
                dispatch(createRouteSuccess(route))
                return route.routeId;
            })
            .catch(error => {
                if (error.message === "401") {
                    dispatch(apiCallUnAuthorised());
                } else {
                    dispatch(apiCallError(error));
                }
                throw error;
            });
    }
}

export function clearDraftRoute() {
    return function (dispatch) {
        dispatch(draftRouteClear());
        dispatch(clearEditRoute());
    }
}

export function undoDraftRoute() {
    return function (dispatch) {
        dispatch(UndoActionCreators.undo());
    }
}

export function redoDraftRoute() {
    return function (dispatch) {
        dispatch(UndoActionCreators.redo());
    }
}

export function setEditingRouteId(details) {
    return function (dispatch) {
        dispatch(setEditRoute(details));
    }
}

export function clearEditingRouteId() {
    return function (dispatch) {
        dispatch(clearEditRoute());
    }
}

export function setReCentreOnMapLoad(state) {
    return function (dispatch) {
        dispatch(setReCentreOnLoad(state));
    }
}

export function shareRoute(route, group, user) {
    return function (dispatch) {
        return routeApi.shareRouteWithGroup(route.routeId, group.id)
            .then(() => {
                var sharedRoute = {
                    groupId: group.id,
                    routeId: route.routeId,
                    routeName: route.name,
                    totalDistance: route.totalDistanceKm,
                    subRegion: route.locationInformation.subRegion,
                    location: route.locationInformation.location,
                    associatedBy: user.userName,
                    associatedById: user.id,
                    associatedOn: "",
                }
                dispatch(routeSharedWithGroup(sharedRoute, group));
            })
            .catch(error => {
                if (error.message === "401") {
                    dispatch(apiCallUnAuthorised());
                } else {
                    dispatch(apiCallError(error));
                }
                throw error;
            });
    }
}

export function unShareRoute(route, group) {
    return function (dispatch) {
        dispatch(removeRouteShareOptimistic(route, group));
        return routeApi.unShareRouteWithGroup(route, group);
    }
}




// WEBPACK FOOTER //
// ./src/redux/actions/routeActions.js